import React from "react";
import PropTypes from "prop-types";
import CnvCall from "../models/CnvCall";
import CnvLink from "../../../components/TooltipActions/CnvLink";
import getPrettyNumberFormat from "../../../helpers/getPrettyNumberFormat";

function CnvCallTitle(props) {
  const { item, actions } = props;
  return item ? (
    <div className="tw-px-1 tw-py-px">
      <div className="tooltip-header border-normal">
        <div className="tooltip-title">
          <CnvLink item={item} />
        </div>
        <div className="tw-w-4" />
        {actions}
      </div>
      <div>
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-24">Type</div>
          <div className="tw-capitalize">{item.type}</div>
        </div>
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-24">Start Position</div>
          <div>
            {item.region.chromosome.name}:{" "}
            {item.region.x0.toLocaleString("en-US")}
          </div>
        </div>
        <div className="tooltip-row">
          <div className="tooltip-label tw-w-24">End Position</div>
          <div>
            {item.region.chromosome.name}:{" "}
            {item.region.x1.toLocaleString("en-US")}
          </div>
        </div>

        <div className="tooltip-row">
          <div className="tooltip-label tw-w-24">Copy Number</div>
          <div>{getPrettyNumberFormat(item.copyNumber)}</div>
        </div>
      </div>
    </div>
  ) : null;
}

CnvCallTitle.propTypes = {
  item: PropTypes.instanceOf(CnvCall).isRequired,
  actions: PropTypes.node,
};

CnvCallTitle.defaultProps = {
  actions: null,
};

export default CnvCallTitle;
